export default "__VITE_ASSET__EaCE8MGZ__"